import { JourneyChoiceGrid as ChoiceGrid } from "../../controls";
import { JOURNEY_FUNDING_OPTIONS, suggestedFundingIntentions } from "../../options";

export const FundingQuestionStep = ({ answers, opportunity, onChange }) => {
  const suggested = suggestedFundingIntentions({
    opportunity_type: opportunity?.opportunity_type,
    qualification_level: opportunity?.qualification_level,
  });
  const options = JOURNEY_FUNDING_OPTIONS.map(([key, label, description]) => (
    suggested.includes(key) ? [key, label, description, "Suggested"] : [key, label, description]
  ));
  return (
    <div>
      <h2 className="font-display text-3xl font-bold tracking-tight text-ink">How do you intend to fund this programme?</h2>
      <p className="mt-2 text-sm leading-6 text-slatey">Funding intention is not funding eligibility. OpenDegree uses it to assess the funding rules that apply to this specific opportunity. Suggestions reflect the programme — you can choose any option.</p>
      <div className="mt-6"><ChoiceGrid options={options} value={answers.funding_intention} onChange={onChange} testId="journey-funding" /></div>
    </div>
  );
};
